import { useSetAllowList } from '../actions/useSetAllowList';
import { useSetLookBackPeriod } from '../actions/useSetLookBackPeriod';
import { useSetName } from '../actions/useSetName';
import { useSetStatus } from '../actions/useSetStatus';
import { useAllowListSelector } from '../selectors/useAllowListSelector';
import { useCampaignSettingsSelector } from '../selectors/useCampaignSettingsSelector';
import { useLookBackPeriodSelector } from '../selectors/useLookBackPeriodSelector';
import { useNameSelector } from '../selectors/useNameSelector';
import { useStatusSelector } from '../selectors/useStatusSelector';
import { useCampaignSchedulingSelector } from '../selectors/useCampaignSchedulingSelector';

export const useCampaignSettings = () => {
  const setAllowList = useSetAllowList();
  const setName = useSetName();
  const setStatus = useSetStatus();
  const setLookBackPeriod = useSetLookBackPeriod();

  const settings = useCampaignSettingsSelector();
  const allowList = useAllowListSelector();
  const name = useNameSelector();
  const status = useStatusSelector();
  const lookBackPeriod = useLookBackPeriodSelector();

  const scheduling = useCampaignSchedulingSelector();

  return {
    setAllowList,
    setName,
    setStatus,
    setLookBackPeriod,

    settings,
    allowList,
    name,
    status,
    lookBackPeriod,
    scheduling,
  };
};
